import ActiveNav from "./_active";
import SpNav from "./_spnavi";
import PageTop from "./_pagetop";
import FadeAnime from "./_animation";
var Script = (function () {
    function Script() {
    }
    Script.prototype.activeNav = function () {
        new ActiveNav().execute();
    };
    Script.prototype.fadeAnime = function () {
        new FadeAnime().execute();
    };
    Script.prototype.spNav = function () {
        new SpNav().execute();
    };
    Script.prototype.pageTop = function () {
        new PageTop().execute();
    };
    Script.prototype.execute = function () {
        this.activeNav();
        this.fadeAnime();
        this.spNav();
        this.pageTop();
    };
    return Script;
}());
var common = new Script();
common.execute();
